import "./gallery.css";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import GalleryApp from "./GalleryApp";

createRoot(document.querySelector("#root")).render(
  <StrictMode>
    <GalleryApp />
  </StrictMode>,
);
